Fundu.Pages.TransactionTable = (function($) {

  var _accountSelector = $("#accountSelector");

  _accountSelector.on('change', function () {
    var accountId = _accountSelector.val();

    window.location.replace(jsRoutes.controllers.AccountCtrl.transactions(accountId).url);
  });

  var initialize = function() {
    return $.Deferred().resolve(true);
  };

  var finalize = function() {

  };

  return {
    init: initialize,
    finalize: finalize
  }

})(jQuery);
